import React, { Component } from "react";
import { Features } from "../../components/features/Features";
import { withRouter } from "react-router-dom";
import { languages } from "../../constants/languages";

class FeaturesContainer extends Component {
  state = {
    features: [],
    featuresLoaded: false
  };

  UNSAFE_componentWillMount = () => {
    let languageIsNL = languages.getLanguage() === "nl";

    this.unsubscribe = window.firebase
      .firestore()
      .collection("features")
      .onSnapshot(querySnapshot => {
        let features = [];
        querySnapshot.forEach(function(doc) {
          let feature = doc.data();
          feature[".key"] = doc.id;
          if (!languageIsNL) {
            if (feature.lang !== undefined) {
              features.push(feature);
            }
          } else {
            if (feature.lang === undefined) {
              features.push(feature);
            }
          }
        });
        features.sort((a, b) => b.date - a.date);
        this.setState({ features: features, featuresLoaded: true });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  handleFeatureClick = (e, featureId) => {
    e.preventDefault();
    this.props.history.push("features/" + featureId);
  };

  handleBackClick = e => {
    e.preventDefault();
    this.props.history.push("");
  };

  render() {
    return (
      <Features
        features={this.state.features}
        user={this.props.user}
        userData={this.props.userData}
        handleFeatureClick={this.handleFeatureClick}
        handleBackClick={this.handleBackClick}
      />
    );
  }
}

export default withRouter(FeaturesContainer);
